// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core/';
import { type ApiInformation } from '../../../../data/cms/types/api-docs';
import { Info } from '../../../../components/alerts';
import './style.css';

type Props = {
    Content: ApiInformation
};
function Information(props: Props) {
    const { Content } = props;
    return (
        <>
            <Typography
                component="p"
                dangerouslySetInnerHTML={{
                    __html: Content.Note
                }}
            ></Typography>
            <Info>{Content.info}</Info>
        </>
    );
}
Information.propTypes = {
    Content: PropTypes.object.isRequired
};
export default Information;
